export const TOPICS_REQUEST = "TOPICS_REQUEST";
export const TOPICS_RECEIVE = "TOPICS_RECEIVE";
export const TOPICS_FAILURE = "TOPICS_FAILURE";
export const RESET_TOPICS = "RESET_TOPICS";